/** Default clock skew when checking JWT `exp` (10 minutes). */
export const DEFAULT_JWT_EXP_SKEW_MS = 10 * 60 * 1000

/** Maps share-grant API `link_*` snake_case fields to camelCase keys used in the app. */
export const SUBTRACE_GRANT_RESPONSE_KEYS = Object.freeze({
  linkCode: 'link_code',
  linkGrantId: 'link_grant_id',
})

/** Login `type` and share `grant_type` field values where the API uses the same literals (`link` / `email`). */
export const LOGIN_TYPE = {
  EMAIL: 'email',
  LINK: 'link',
}

/**
 * Session / HTTP client scope: which bearer token and grant cache apply (workspace map vs link invite).
 * Use as axios request `authScope` and Vue props (`auth-scope`).
 */
export const AUTH_SCOPE = Object.freeze({
  MAP: 'map',
  LINK: 'link',
})
